/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const DOWNLOAD_CREDENTIAL_ZIP_V2 = gql`
  mutation DownloadCredentialZipV2($input: DownloadCredentialZipInput!) {
    downloadCredentialZipV2(input: $input) {
      fileName
      base64
      contentType
      parts {
        fileName
        base64
        contentType
      }
      presignedUrls {
        fileName
        url
        base64
      }
    }
  }
`;
